import { type UseQueryResult, useQuery } from 'react-query';
import {
  CompanySsoConfigurationService,
  Wealthlane_Dtos_SsoProvider_CompanySsoConfigurationDto,
} from '../../services/wealthlane-identity-services';

const useGetCompanySsoConfigById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | (Wealthlane_Dtos_SsoProvider_CompanySsoConfigurationDto & {
      providerSigningCertificate?: string;
    })
  | undefined,
  unknown
> => {
  const companySsoConfigById = useQuery(
    ['getCompanySsoConfigById', id],
    async () => {
      const response = await handleRequest(
        CompanySsoConfigurationService.getApiIdentityApiAppCompanySsoConfiguration1(id)
      );
      return {
        ...response,
        providerSigningCertificate: '',
      };
    },
    {
      enabled: !!id,
    }
  );

  return companySsoConfigById;
};

export default useGetCompanySsoConfigById;
